module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"current_reward":"現在の報酬","remaining_reward":"残りの獲得可能報酬"}}')
  delete Component.options._Ctor
}
